import { DropDownItem } from "../../../pojo/DropDownItem";
import { Nullable } from "../../../pojo/Util";
import { Workflow } from "../../workflow/service/Workflow";

export function workflowProcessToDropDownItem(process: Workflow.WorkflowProcess): DropDownItem {
    const name = process.workflowProcessName || `Workflow #${process.workflowProcessId}`;
    return {
        txt: name,
        val: process.workflowProcessId,
        itemId: process.workflowProcessId,
        itemName: name,
        itemTypeId: Workflow.WORKFLOW_PROCESS_TYPE_ID,
        data: process,
    };
}

export function workflowFallbackLabel(selectedId: number, selectedLabel?: string): string {
    return selectedLabel ?? `Workflow #${selectedId}`;
}

export function buildWorkflowDropdownItems(
    workflows: Workflow.WorkflowProcess[],
    selectedId?: Nullable<number>,
    selectedLabel?: string,
): DropDownItem[] {
    const items = workflows.map(workflowProcessToDropDownItem);
    items.sort((left, right) => (left.txt ?? "").localeCompare(right.txt ?? ""));

    if (selectedId != null && !items.some((item) => String(item.itemId) === String(selectedId))) {
        const label = workflowFallbackLabel(selectedId, selectedLabel);
        items.push({
            txt: label,
            val: selectedId,
            itemId: selectedId,
            itemName: label,
            itemTypeId: Workflow.WORKFLOW_PROCESS_TYPE_ID,
        });
    }

    return items;
}

export function findSelectedWorkflowDropdownItem(
    items: DropDownItem[],
    selectedId?: Nullable<number>,
): DropDownItem | undefined {
    if (selectedId == null) return undefined;
    return items.find((item) => String(item.itemId) === String(selectedId));
}
